import InitialState from 'store/InitialState';
import { studentGroupConceptsActionTypes as types } from 'Screens';

export default function studentGroupConceptsReducer(state = InitialState.studentGroupConceptsMap, action) {
    switch (action.type) {
        case types.LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS:
            let {groupid,concepts} = action;
            let newState = new Map(state)
            newState.set(groupid,concepts);
            return newState;

        case types.LOAD_STUDENT_GROUP_CONCEPTS_FAILURE:
            return state;

        default:
            return state;
    }
}